module.exports = __webpack_public_path__ + "media/images/flags/64/Israel-e90d08fba5eed17d1207a9bf4f502f27.png";